import { injectable } from 'inversify';
import { constraint_full, constraint_scopes } from '@Api';
import {
  Constraint,
  ConstraintField,
  ConstraintScope,
  ConstraintType,
} from '@Models';

@injectable()
export class ConstraintMapper {
  public map(item: constraint_full): Constraint {
    return {
      id: item.id,
      name: item.name,
      versionId: item.version_id,
      armyId: item.army_id,
      armyOrganisationId: item.army_organisation_id,
      includeChildSelections: item.include_child_selections,
      scope: this.mapScope(item.scope),
      shared: item.shared,
      type: this.mapType(item.limit),
      value: item.value,
      percentValue: item.percent_value,
      field: this.mapField(item.field),
    } satisfies Constraint as Constraint;
  }

  mapScope(scope: constraint_scopes): ConstraintScope {
    switch (scope) {
      case constraint_scopes.ROSTER:
        return ConstraintScope.Roster;
      case constraint_scopes.FORCE:
        return ConstraintScope.Force;
    }

    return ConstraintScope.Parent;
  }

  mapType(type: constraint_full.limit): ConstraintType {
    switch (type) {
      case constraint_full.limit.MIN:
        return ConstraintType.Min;
    }

    return ConstraintType.Max;
  }

  mapField(field: constraint_full.field): ConstraintField {
    switch (field) {
      case constraint_full.field.MODELS:
        return ConstraintField.Models;
      case constraint_full.field.POINTS:
        return ConstraintField.Points;
    }

    return ConstraintField.Selections;
  }
}
